<template>
  <div v-if="headings.length">
    <v-expansion-panels v-model="expanded">
      <v-expansion-panel>
        <v-expansion-panel-title>
          {{ $tt('blog.table_of_contents') }}
        </v-expansion-panel-title>
        <v-expansion-panel-text class="pb-5">
          <ul class="flex col gap-3">
            <li v-for="heading in headings">
              <AppLink class="plain" :to="`#${heading.id}`">
                {{ heading.textContent }}
              </AppLink>
            </li>
          </ul>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  headings: HTMLElement[];
}>();

const { desktop } = useBreakpoints();
const expanded = ref(desktop.value ? [0] : []);
</script>

<style scoped>
ul li {
  font-size: 14px;
}
.v-expansion-panels, .v-expansion-panel {
  border-radius: var(--border-r-lg);
}
:deep(.v-expansion-panel-text__wrapper) {
  padding-inline: var(--space-7);
}
@media (max-width: 850px) {
  .v-expansion-panels {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  :deep(.v-expansion-panel-text__wrapper) {
    padding: 0 var(--space-6) !important;
  }
}
</style>